<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="success">
            <b-navbar-brand href="#"
                ><img src="/img/logo_navbar.png"
            /></b-navbar-brand>
        </b-navbar>
        <br />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-2"><h2>ARBORESCENCE</h2></div>
                <div class="col-lg-1">
                    <b-icon-unlock
                        font-scale="2"
                        v-if="lock == false"
                        v-on:click="lockTree"
                        style=" cursor: pointer"
                    ></b-icon-unlock>
                    <b-icon-lock-fill
                        font-scale="2"
                        v-if="lock == true"
                        v-on:click="lockTree"
                        style=" cursor: pointer"
                    ></b-icon-lock-fill>
                </div>
                <div class="col-lg-1">
                    <b-icon-arrows-collapse
                        font-scale="2"
                        v-if="expandLogo == false"
                        v-on:click="expandTree(false)"
                        style=" cursor: pointer"
                    ></b-icon-arrows-collapse>
                    <b-icon-arrows-expand
                        font-scale="2"
                        v-if="expandLogo == true"
                        v-on:click="expandTree(true)"
                        style=" cursor: pointer"
                    ></b-icon-arrows-expand>
                </div>
                <div class="col-lg-1">
                    <b-button v-on:click="goPreview" variant="success"
                        >Prévisualiser</b-button
                    >
                </div>
                <div class="col-lg-1">
                    <b-button v-on:click="goEdit" variant="success"
                        >Editer Projet</b-button
                    >
                </div>
                <div class="col-lg-1">
                    <b-button variant="success" v-on:click="download">
                        Télécharger
                    </b-button>
                </div>

                <div class="col-lg-1">
                    <b-button
                        variant="outline-success"
                        v-on:click="downloadCsv"
                    >
                        Export Sheet</b-button
                    >
                </div>

                <div class="col-lg-1 custom-file">
                    <label class="btn btn-outline-success" for="arbo"
                        >Importer</label
                    >
                    <input
                        class="custom-file-input outline-success"
                        type="file"
                        id="arbo"
                        @change="arboImport"
                    />
                </div>
            </div>
            <br /><br />
            <div class="row">
                <div class="col-12">
                    <nested-draggable
                        :list="data.list"
                        :lock="lock"
                        @make-folder="makeFolder"
                        @add-item="addItem"
                        @check-level="checkLevel"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nestedDraggable from "./nested";
import FileSaver from "file-saver";
import Papa from "papaparse";
import _ from "lodash";
export default {
    name: "nested-example",
    display: "Nested",
    order: 15,
    components: {
        nestedDraggable
    },
    data() {
        return {
            data: {
                list: [
                    {
                        name: "",
                        frontcolor: "#FFFFFF",
                        backcolor: "",
                        icon: "autre",
                        bank: "base",
                        iconcolor: "",
                        isFolder: false,
                        isOpen: true,
                        show: false,
                        lock: false,
                        breadcrumb: "IconBreadcrumb",
                        main: "SimpleListMenu",
                        menuitem: "FirstMenuItem",
                        children: []
                    }
                ],
                menu_style: {
                    ref: "KomuraMenu",
                    primary: "",
                    secondary: "",
                    imageHeader: "",
                    imageLogo: "",
                    imageHeight: ""
                }
            },
            jsonFormat: [],
            lock: false,
            expandLogo: true
        };
    },
    beforeMount() {
        if (this.$route.params.menu) {
            this.data = this.$route.params.menu;
        }
    },
    watch: {
        data: [
            {
                handler: "checkLevel"
            }
        ]
    },
    methods: {
        makeFolder: function(item) {
            item.children = [];
            item.isFolder = true;
            this.addItem(item);
        },
        addItem: function(item) {
            item.children.push({
                name: "",
                frontcolor: "#FFFFFF",
                backcolor: "",
                icon: "autre",
                iconcolor: item.iconcolor,
                isFolder: true,
                isOpen: true,
                show: false,
                lock: false,
                breadcrumb: "IconBreadcrumb",
                main: "SimpleListMenu",
                menuitem: "SimpleMenuItem",
                children: []
            });
        },
        goPreview: function() {
            this.$router.push({
                name: "Preview",
                params: {
                    menu: this.data
                }
            });
        },
        goEdit: function() {
            this.$router.push({
                name: "Edit",
                params: {
                    menu: this.data
                }
            });
        },
        download: function() {
            let json = JSON.stringify(this.data.list);
            let blob = new Blob([json], { type: "application/json" });
            FileSaver.saveAs(blob, "arbo.kalkin");
        },
        downloadStyle: function() {
            this.$refs.edit.download();
        },
        arboImport: function(e) {
            let test = e.target.files[0];
            let reader = new FileReader();
            reader.onload = () => {
                this.setArbo(reader.result);
            };
            reader.readAsText(test);
        },
        setArbo(menu) {
            this.data.list = JSON.parse(menu);
        },
        downloadCsv: function() {
            this.convertJson(this.data.list, 0);
            let csv = Papa.unparse(this.jsonFormat, {
                header: false,
                delimiter: "\t"
            });

            let blob = new Blob([csv], { type: "text/csv" });
            FileSaver.saveAs(blob, "arbo.csv");
        },
        convertJson: function(item, i) {
            i = i + 1;
            item.forEach(element => {
                this.jsonFormat.push({
                    niveau: i,
                    id: this.parseId(element.name, "id"),
                    nom: element.name,
                    main: element.main,
                    menu_item: element.menuitem,
                    breadcrumb: element.breadcrumb,
                    style: this.parseId(element.name, "style"),
                    dataselections: "",
                    version: "2",
                    main2: element.main,
                    menuitem2: element.menuitem,
                    style2: this.parseId(element.name, "style")
                });

                this.convertJson(element.children, i);
            });
        },
        parseId: function(name, type) {
            let text = "";
            if (type == "id") {
                text = _.deburr(
                    _.words(_.toLower(name))
                        .reduce((acc, cur) => {
                            if (
                                cur.length >= 3 &&
                                cur !== "des" &&
                                cur !== "les"
                            ) {
                                acc.push(cur);
                            }
                            return acc;
                        }, [])
                        .join("_")
                );
            }
            if (type == "style") {
                text = _.deburr(
                    _.words(_.toLower(name))
                        .reduce((acc, cur) => {
                            if (
                                cur.length >= 3 &&
                                cur !== "des" &&
                                cur !== "les"
                            ) {
                                acc.push(cur);
                            }
                            return acc;
                        }, [])
                        .join("-")
                );
            }
            return text;
        },
        checkLevel: function() {
            this.getLevel(this.data.list, 0);
            console.log("i");
        },
        getLevel: function(item, i) {
            i = i + 1;
            item.forEach(element => {
                if (i > 6) {
                    console.log("test");
                    element.lock = true;
                    element.isFolder = false;
                    element.children = [];
                } else {
                    element.lock = false;
                    element.isFolder = true;
                    element.menuitem = "SimpleMenuItem";
                }
                if (i == 1) {
                    element.menuitem = "FirstMenuItem";
                }

                this.getLevel(element.children, i);
            });
        },
        lockTree: function() {
            this.lock = !this.lock;
        },
        expandTree: function(bool) {
            if (bool == true) {
                this.expand(this.data.list);
                this.expandLogo = false;
            } else {
                this.collapse(this.data.list);
                this.expandLogo = true;
            }
        },
        expand: function(menus) {
            console.log("ouvi=rir");
            menus.forEach(element => {
                element.isOpen = false;
                this.expand(element.children);
            });
        },
        collapse: function(menus) {
            console.log("fermer");
            menus.forEach(element => {
                element.isOpen = true;
                this.collapse(element.children);
            });
        }
    }
};
</script>
<style scoped></style>
